import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Rocket, Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Error al iniciar sesión");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-6.4rem)] flex items-center justify-center px-5 py-16 science-grid bg-paper-50">
      <div className="w-full max-w-md">
        <div className="bg-white border border-paper-200 border-t-4 border-t-nasa-blue shadow-xl p-8">
          <div className="flex items-center gap-3 mb-8">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-nasa-blue text-white"><Rocket size={22} /></span>
            <div>
              <h1 className="font-display font-extrabold text-xl text-nasa-blue">Acceso Admin</h1>
              <p className="eyebrow text-nasa-blue text-[10px] mt-0.5">EL PORTAL DE LA CIENCIA</p>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="eyebrow text-ink-500 block mb-2">Correo</label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="admin@portalciencia.com" />
            </div>
            <div>
              <label className="eyebrow text-ink-500 block mb-2">Contraseña</label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" />
            </div>
            {error && <p className="text-nasa-red text-sm font-medium" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-nasa-blue text-white hover:bg-nasa-navy font-semibold h-11 rounded-full">
              {loading ? <Loader2 className="animate-spin" size={18} /> : <><Lock size={16} className="mr-2" /> Entrar</>}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
